import { useMemo } from "react";
import { useSelector } from "react-redux";
import { RootState } from "../store/store";
import { Manager } from "../types/manager.definition";

function useManager(): Manager {
  const { session } = useSelector((state: RootState) => state.session);

  return useMemo(() => {
    const { user, metadata } = session ?? {};
    // Merge the user, patient metadata, and appointment into a single patient object
    const manager: Manager = {
      ...user,
      ...metadata?.manager,
      id: metadata?.manager?.id,
      userId: user?.id,
      photoUrl: user?.photoUrl,
      email: user?.email,
      civility: user?.civility,
      roleName: user?.roleName,
      firstName: user?.firstName,
      phoneNumber: user?.phoneNumber,
      lastName: user?.lastName,
      preferredNotificationMethods: user?.preferredNotificationMethods || [],
    } as Manager;

    return manager;
  }, [session]);
}

export default useManager;
